"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _assign2 = _interopRequireDefault(require("lodash/fp/assign"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 *
 * A utility function that composes multiple request middlewares into a single function.
 * This can be used to create more complex `before` hooks for {@link http}.
 *
 * @name composeMiddleware
 * @type Function
 * @param {...Function} middlewares - Functions that receive and return request options
 * @returns {Function} A composed middleware function
 *
 * @example
 *
 * function addBearerToken () {
 *    const token = getTokenFromStorage()
 *    if (token) return { bearerToken: token }
 * }
 * 
 * function addPathToUrl ({ url }) {
 *    return {
 *      url: url + '/some-path'
 *    }
 * }
 * 
 * const before = composeMiddleware(
 *    addBearerToken,
 *    addPathToUrl,
 * )
 * 
 * // this will call both middlewares before the request
 * http('/users', { before }) 
 * 
 * 
 */
function composeMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  // Note: An async reducer is used because we want to allow middleware
  // to return promises if they want.
  var asyncMiddlewares = middlewares.map(_utils.ensureAsync);
  return function callMiddleware(initialValue) {
    return (0, _utils.asyncReduce)(asyncMiddlewares,
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(acc, middleware) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return middleware(acc);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", (0, _assign2["default"])(acc, result || {}));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), initialValue);
  };
}

var _default = composeMiddleware;
exports["default"] = _default;